// extracted by mini-css-extract-plugin
export default {"notificationSubject":"Notifications_notificationSubject__OBODC","notificationMessage":"Notifications_notificationMessage__HMHtK"};